"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateCart = void 0;

var _useMutation = require("../lib/use-mutation");

var _documents = require("./documents");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var useCreateCart = () => {
  var {
    mutate,
    loading
  } = (0, _useMutation.useMutation)(_documents.CREATE_CART);

  var create = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (services, referToken) {
      return mutate({
        input: {
          services,
          referToken
        }
      });
    });

    return function create(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    create,
    loading
  };
};

exports.useCreateCart = useCreateCart;